const screenLookup = {
  login: {
    action: "USER_MANAGEMENT",
    function: "login",
    version: "1",
    screenName: "LoginScreen",
  },
  add_subscription: {
    action: "SUBSCRIPTION_MANAGEMENT",
    function: "update_subscription",
    version: "1",
    screenName: "CartDetailsScreen",
  },
  forgot_pasword: {
    action: "USER_MANAGEMENT",
    function: "forgot_password",
    version: "1",
    screenName: "ForgotPasswordScreen",
  },
  reset_pasword: {
    action: "USER_MANAGEMENT",
    function: "new_password",
    version: "1",
    screenName: "ForgotPasswordScreen",
  },
  AnonymousUserScreen: {
    action: "USER_MANAGEMENT",
    function: "anonymous_user",
    version: "1",
    screenName: "AnonymousUserScreen",
  },
  change_password: {
    action: "USER_MANAGEMENT",
    function: "update_password",
    version: "1",
    screenName: "AccountSettingScreen",
  },
  update_profile: {
    action: "USER_MANAGEMENT",
    function: "update_profile",
    version: "1",
    screenName: "AccountSettingScreen",
  },
  card_details_serial: {
    action: "CARD_MANAGEMENT",
    function: "card_details_serial",
    version: "1",
    screenName: "CardDetailsScreen",
  },
  recharge_card: {
    action: "CARD_MANAGEMENT",
    function: "recharge_card",
    version: "1",
    screenName: "RechargeScreen",
  },
  create_group: {
    action: "GROUP_MANAGEMENT",
    function: "create_group",
    version: "1",
    screenName: "GroupDetailsScreen",
  },
  card_allocation: {
    action: "EMPLOYEE_MANAGEMENT",
    function: "create_employee",
    version: "1",
    screenName: "EmployeeDetailsScreen",
  },
  create_employee: {
    action: "EMPLOYEE_MANAGEMENT",
    function: "create_employee",
    version: "1",
    screenName: "EmployeeDetailsScreen",
  },
  subscription_payment: {
    action: "SUBSCRIPTION_MANAGEMENT",
    function: "add_subscription",
    version: "1",
    screenName: "CartDetailsScreen",
  },
  subscription_address: {
    action: "SUBSCRIPTION_MANAGEMENT",
    function: "add_subscription",
    version: "1",
    screenName: "CartDetailsScreen",
  },
  order_payment: {
    action: "ORDER_MANAGEMENT",
    function: "submit_order",
    version: "1",
    screenName: "Order Screen",
  },
  order_address: {
    action: "ORDER_MANAGEMENT",
    function: "submit_order",
    version: "1",
    screenName: "Order Screen",
  },
  feedback_form: {
    action: "FEEDBACK_FORM",
    function: "submit",
    version: "1",
    screenName: "FeedbackScreen",
  },
  sponser_subscription_management: {
    action: "SPONSER_SUBSCRIPTION_MANAGEMENT",
    function: "add_subscription",
    version: "1",
    screenName: "RS Add Subscription",
  },
};

export default screenLookup;
